import { appShell as deAppShell } from './locales/de/app-shell';
import { auth as deAuth } from './locales/de/auth';
import { breadcrumbs as deBreadcrumbs } from './locales/de/breadcrumbs';
import { common as deCommon } from './locales/de/common';
import { contract as deContract } from './locales/de/contract';
import { developer as deDeveloper } from './locales/de/developer';
import { documents as deDocuments } from './locales/de/documents';
import { driver as deDriver } from './locales/de/driver';
import { locations as deLocations } from './locales/de/locations';
import { orgUnit as deOrgUnit } from './locales/de/orgUnit';
import { tenant as deTenant } from './locales/de/tenant';
import { users as deUsers } from './locales/de/users';
import { vehicle as deVehicle } from './locales/de/vehicle';
import { appShell as enAppShell } from './locales/en/app-shell';
import { auth as enAuth } from './locales/en/auth';
import { breadcrumbs as enBreadcrumbs } from './locales/en/breadcrumbs';
import { common as enCommon } from './locales/en/common';
import { contract as enContract } from './locales/en/contract';
import { developer as enDeveloper } from './locales/en/developer';
import { documents as enDocuments } from './locales/en/documents';
import { driver as enDriver } from './locales/en/driver';
import { locations as enLocations } from './locales/en/locations';
import { orgUnit as enOrgUnit } from './locales/en/orgUnit';
import { tenant as enTenant } from './locales/en/tenant';
import { users as enUsers } from './locales/en/users';
import { vehicle as enVehicle } from './locales/en/vehicle';

// One namespace per file/domain. Adding a domain here (plus its en+de file) is
// the whole registration step; the module augmentation in ../i18next.d.ts and
// the `ns` list in ./index.ts both derive from this object.
export const resources = {
  en: {
    common: enCommon,
    appShell: enAppShell,
    breadcrumbs: enBreadcrumbs,
    auth: enAuth,
    tenant: enTenant,
    vehicle: enVehicle,
    contract: enContract,
    driver: enDriver,
    documents: enDocuments,
    developer: enDeveloper,
    users: enUsers,
    orgUnit: enOrgUnit,
    locations: enLocations,
  },
  de: {
    common: deCommon,
    appShell: deAppShell,
    breadcrumbs: deBreadcrumbs,
    auth: deAuth,
    tenant: deTenant,
    vehicle: deVehicle,
    contract: deContract,
    driver: deDriver,
    documents: deDocuments,
    developer: deDeveloper,
    users: deUsers,
    orgUnit: deOrgUnit,
    locations: deLocations,
  },
};

// English is the canonical shape; the i18next module augmentation derives its
// key types from this (see ../i18next.d.ts).
export type AppResources = (typeof resources)['en'];

// The namespace names, as a literal tuple. Used for i18next's `ns` option AND as
// the `defaultNS`: making every namespace part of the default is what lets a
// bare `useTranslation()` reach any key, type-safely, via the `ns:key` form
// (e.g. `t('vehicle:list.title')`) — no per-component namespace argument. A bare
// key with no `ns:` prefix resolves against the first entry, `common`.
export const NAMESPACES = [
  'common',
  'appShell',
  'breadcrumbs',
  'auth',
  'tenant',
  'vehicle',
  'contract',
  'driver',
  'documents',
  'developer',
  'users',
  'orgUnit',
  'locations',
] as const satisfies readonly (keyof AppResources)[];

export const defaultNS = NAMESPACES;
